import * as React from 'react';
import { Text, Link, Divider, tokens } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { TeamCollaboration } from './TeamCollaborationImage';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  max-width: 100%;
  margin: ${tokens.spacer.x7} auto ${tokens.spacer.x2};
  padding: 0 ${tokens.spacer.x3};
  text-align: center;

  @media ${tokens.breakpoint.minWidth.m} {
    max-width: 632px;
  }
`;

const Title = styled(Text)`
  ${tokens.text('header4')};
  color: ${tokens.color.text_default};
  margin-bottom: ${tokens.spacer.x3};
  overflow: initial;

  @media ${tokens.breakpoint.minWidth.s} {
    ${tokens.text('header2')};
  }
`;

const LinksWrapper = styled.div`
  margin: ${tokens.spacer.x3} 0;
  display: flex;
  flex-direction: column;

  @media ${tokens.breakpoint.minWidth.s} {
    justify-content: space-evenly;
    flex-direction: row;
  }
`;

const StyledText = styled(Text)`
  margin-bottom: ${tokens.spacer.x3};
`;

const StyledLink = styled(Link)`
  ${tokens.text('body2')};
  margin-bottom: ${tokens.spacer.x3};
`;

const SupportLink = styled(Link)`
  ${tokens.text('body1')};
`;

export const InvalidTokenScreen = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Title as="h1">{t('common:registration.from-invite.invalid-invite.title')}</Title>
      <StyledText as="p" textType="body1" textColor="text_light">
        {t('common:registration.from-invite.invalid-invite.subtitle')}
      </StyledText>
      <StyledText as="p" textType="subtitle1" textColor="text_default">
        {t('common:registration.from-invite.invalid-invite.admin-text')}
      </StyledText>
      <StyledText as="p" textType="body1" textColor="text_light">
        {t('common:registration.from-invite.invalid-invite.support-text')}
        <SupportLink kind="inline" isExternal href="https://hotjar.com/contact">
          {t('common:registration.from-invite.invalid-invite.support-link')}
        </SupportLink>
        .
      </StyledText>
      <Divider />
      <LinksWrapper>
        <StyledLink kind="standalone" href="https://www.hotjar.com/" isExternal>
          {t('common:registration.from-invite.invalid-invite.homepage-link')}
        </StyledLink>
        <StyledLink kind="standalone" href="https://www.hotjar.com/blog/" isExternal>
          {t('common:registration.from-invite.invalid-invite.blog-link')}
        </StyledLink>
        <StyledLink kind="standalone" href="https://www.hotjar.com/guides/" isExternal>
          {t('common:registration.from-invite.invalid-invite.guides-link')}
        </StyledLink>
      </LinksWrapper>
      <TeamCollaboration />
    </Wrapper>
  );
};
